// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_an-3";
export var contentContainer = "_an-0";
export var editorContainer = "_an-1";
export var quillInputForm = "_an-2";
export var zoneDivider = "_an-4";